import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default function routes(components) {
    let TEXT = Vue.prototype.TEXT || {}
    let CONFIG = Vue.prototype.CONFIG || {}

    let REWARDS = CONFIG.RewardsProgram || {}

    var routes = [
        // -------------- Public Links ---------------------- //
        {
            path: '/login',
            name: "Login",
            meta: {
                title: [TEXT.REWARDS_PROGRAM, 'Login'].join(' ')
            }
        },
        {
            path: '/recover',
            name: "ForgotPassword",
            meta: {
                subtitle: 'Forgot Password'
            }
        },
        {
            path: '/enroll',
            name: "EnrollmentView",
            meta: {
                subtitle: 'Enroll Now'
            }
        },
        {
            path: '/about',
            beforeEnter() { location.href = REWARDS.AboutURL },
            meta: {
                title: `About ${TEXT.REWARDS_PROGRAM}`
            }
        },
        {
            path: '/terms',
            beforeEnter() { location.href = REWARDS.TermsURL },
            meta: {
                title: `Terms and Conditions`
            }
        },

        // -------------- Member Links ---------------------- //
        {
            path: '/account',
            name: "MyAccount",
            props: true,
            meta: {
                subtitle: 'My Account'
            }
        },
        {
            path: '/history',
            name: "TransactionHistory",
            props: true,
            meta: {
                subtitle: 'Transaction History'
            }
        },
        {
            path: '/contact',
            name: "ContactInfo",
            meta: {
                subtitle: 'Contact Info'
            }
        },
        {
            path: '/reset/:token?/:special?',
            name: "ResetPassword",
            props: true,
            meta: {
                subtitle: 'Reset Password'
            }
        },
        {
            path: '/wallet',
            name: "Wallet",
            meta: {
                subtitle: 'Wallet'
            }
        },
        {
            path: '/flight',
            beforeEnter() { location.href = "/bookings/members.aspx" },
            meta: {
                title: `Book a Flight`
            }
        },
        {
            path: '/redeem',
            beforeEnter() { location.href = "/bookings/Vues/flight_selection.aspx?SS=FFR&PA=1" },
            meta: {
                title: `Redeem Miles`
            }
        }
    ]

    routes.filter(route => route.name).forEach(route => route.component = components[route.name])

    if (!REWARDS.AboutURL)
        routes = routes.filter(route => route.path != '/about')

    if (!REWARDS.TermsURL)
        routes = routes.filter(route => route.path != '/terms')

    const router = new VueRouter({ routes })

    router.beforeEach((to, from, next) => {
        let meta = to.meta || {}
        document.title = meta.title || [TEXT.REWARDS_PROGRAM, meta.subtitle].filter(t => t).join(': ');
        next();
    })

    return router
}